<template>
  <v-app>
  
    <v-app-bar app clipped-left v-if="!isLoading && !accessError" dark dense flat class="primary flexiapp-header-bar">
   
      <v-toolbar-items>
        <img v-if="!navTitle" src = 'img/logo-tiba-blanco.png' height="38px" style="padding-top:10px;"/>
        <span @click="$router.go(-1)" v-if="navTitle" style="padding-top:10px; cursor:pointer; font-size:1.2rem;"><v-icon class="mr-2">mdi-arrow-left</v-icon>{{this.navTitle}}</span>
      </v-toolbar-items>

      <v-spacer></v-spacer>

      <span class="light--text flexiapp-username-header">{{ username }}</span>

        <OfflineImagesDialog
            ref="offlineImagesDialog"
        />

    <v-menu :close-on-content-click="false" bottom left style="z-index: 10;">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="light--text"
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
          <v-btn 
            @click="showOfflineImages()"
          class="light--text"
          icon
          >
          <v-badge 
            color="red" v-if="badgeCount>0"
            :content="badgeCount"
            overlap>
              <v-icon>mdi-sync-alert</v-icon>
          </v-badge>
        </v-btn>
        <!--<v-icon class="light--text">{{ isNetworkAvailable? 'mdi-wifi-alert' : ''}}</v-icon>-->
        <v-icon class="light--text">{{ isNetworkAvailable? '' : 'mdi-access-point-off'}}</v-icon>
      </template>

      <v-list style="border-radius: 0;">
            <v-list-group>
                <template v-slot:activator>
                <v-list-item-title>{{$t('language.select.label')}}</v-list-item-title>
                </template>        
                <v-list> 
                    <v-list-item
                        :class="$i18n.locale === locale.value ? 'selectedLanguage' : ''"
                        v-for="(locale, i) in getLocales" 
                        :key="`locale-${i}`"
                        :value="locale.value"
                    >
                        <v-list-item-title 
                            v-on:click="setLanguage(locale.value)">
                            {{locale.title}}
                        </v-list-item-title>
                    </v-list-item>
                </v-list>                
            </v-list-group>
      </v-list>       
                        
      <v-list style="border-radius: 0;">
        <v-list-item  @click="logout()">
          <v-list-item-title>{{$t("app.closeSession")}}</v-list-item-title>
        </v-list-item>
      </v-list>

    </v-menu>

    <!--<template v-slot:extension>
        <v-tabs 
        centered 
        grow 
        style="position: relative; top: 24px;"
        >
          <v-tab>En curso</v-tab>
          <v-tab>Completados</v-tab>
        </v-tabs>
      </template>-->

  </v-app-bar>


  <!-- Sizes your content based upon application components -->
  <v-main v-if="!isLoading" >

    <v-container fluid class="flexiapp-main-container"
      style="background-color: #F1F5F9; height: 100vh;">
        
      <transition :name="transitionName">
        <keep-alive>
        <router-view></router-view>
       </keep-alive> 
      </transition>
      
    </v-container>
  </v-main>

</v-app>
</template>

<script>
import BaseModule from './components/common/BaseModule'
import OfflineImagesDialog from './components/modules/offline/OfflineImagesDialog'
import pictureManager from "./components/common/PictureManager";
import cordova from "./api/cordova";

export default {
  name: 'App',
  mixins: [BaseModule],
  components: {OfflineImagesDialog
  },

  data () {
      return {
          transitionName: 'slide-left',
          isLoading: false,
          networkPeriod: null,
          locale: null,        
      }
    },
    computed: {
        getLocales() {
            return [
            {title: this.$t("language.spanish.label"), value: 'es'},
            {title: this.$t("language.english.label"), value: 'en'}
          ]
        },
        accessError() {
            return !this.$store.state.flexiapp.token || !this.$store.state.flexiapp.user.userId;
        },
        username() {
            return this.$store.state.flexiapp.user.CompleteName;
      },
        navTitle() {
            return this.$store.state.flexiapp.navTitle;
        },
        badgeCount(){
            return this.$store.state.flexiapp.pendingOfflineUploadImageCount;
        },
        /*isWifiAvailable() {
            return this.$store.state.flexiapp.isWifiAvailable;
        },*/
        isNetworkAvailable() {
            return this.$store.state.flexiapp.isNetworkAvailable;
        },
    },
    mounted: function () {
        pictureManager.init();
        cordova.init();
        
        this.networkPeriod = setInterval(function () {
            cordova.getNetworkUpdate();
            }.bind(this), 30000); 

    },  
    beforeDestroy: function(){
        clearInterval(this.networkPeriod);
        
    },   
  methods: {      
        logout: function() {
            this.$store.commit('flexiapp/setUser', {});
            this.$store.commit('flexiapp/setToken', null);
            this.$router.push({ name: 'login' });
            location.reload(true);
        },
        showOfflineImages(){
            if(this.$refs.offlineImagesDialog){
                this.$refs.offlineImagesDialog.showDialog();
            }
        },
        setLanguage(locale) {
            console.log(locale);
            window.localStorage.setItem("user-config-lang", locale);
            this.$i18n.locale = locale;
        },                
  },

watch: {
  '$route' (to, from) {
    const toDepth = to.path.split('/').length
    const fromDepth = from.path.split('/').length
    this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
    pictureManager.updateStats();
  }
}
};
</script>

<style scoped>
    .app-main {
        background: #f1f4f6;
    }
    .selectedLanguage {
        background-color: #B3D4FC;
    }    
</style>